import { FormItemProps } from '@/components/Form/types'


const Items: Array<FormItemProps> = [
	{
		name: 'previewStyle',
		type: 'Select',
		help: 'Choose the uploaded style used to generate the font thumbnail and preview image.',
		itemOptions: {
			list: [],
			features: {
				needToUpdateOnOpen: true
			}
		},
		classNames: {
			container: 'col-span-6',
		}

	},
];


export default Items;
